import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {UpdateLookupVo} from '../../../model/updateLookupVo';
import {Constants} from '../../../constants/ebtq-constants';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {UserDetailsModel} from '../../../constants/userModel';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-gse-limit',
  templateUrl: './gse-limit.component.html',
  styleUrls: ['./gse-limit.component.scss']
})
export class GseLimitComponent implements OnInit {
  state!: any[];
  selectedState!: string;
  currentVal!: string;
  showVal = false;
  displayState!: string;
  updatVal: string;
  successMess: boolean;
  showErrorDiv: boolean;
  errMessage: string;
  errHeading: string;
  containsError = false;
  errorMsg!: string;
  userDetails!: UserDetailsModel;
  title = 'Update GSE Table';

  constructor(private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService,
              private titleService: Title, private cdr: ChangeDetectorRef) {
    this.successMess = false;
    this.showErrorDiv = false;
    this.errHeading = Constants.ERROR_HEADER;
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.getStateList();
  }

  getStateList() {
    this.apiService.getStateList()
      .subscribe(
        (data: any) => {
          this.state = [];
          for (const stateName of data) {
            this.state.push({label: stateName, value: stateName});
          }
          this.selectedState = data[0];
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });
    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        if (message.includes('Unable to update')) {
          this.showErrorDiv = true;
          this.errMessage = Constants.UNEXPCT_ERROR;
        } else {
          this.errorMsg = message;
          this.containsError = true;
        }
        this.cdr.detectChanges();
      });
  }

  updateGseLimit() {
    const rgx = /^[0-9]*\.?[0-9]*$/;
    this.successMess = false;
    this.showErrorDiv = false;
    this.userDetails = Constants.USER_DETAILS;
    if (this.updatVal.trim() === '') {
      this.showErrorDiv = true;
      this.errMessage = Constants.MAX_CLAIM_EMPT_MESS;
    } else if (this.updatVal.trim().match(rgx)) {
      const request = new UpdateLookupVo();
      request.stateName = this.selectedState;
      request.userID = this.userDetails.uid;
      request.gseAmt = this.updatVal;
      this.apiService.updateGseLimit(request)
        .subscribe((data: any) => {
          if (data === 1) {
            this.currentVal = this.updatVal;
            this.successMess = true;
          } else {
            this.showErrorDiv = true;
            this.errMessage = Constants.SOMETHING_MESS;
          }
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });
      this.errorAnnouncement();
    } else {
      this.errMessage = Constants.MAX_CLAIM_INCRT_FRMT_MESS;
      this.showErrorDiv = true;
    }
  }

  getGseLimit() {
    this.apiService.getGseLimit(this.selectedState)
      .subscribe(
        (data: any) => {
          this.showVal = true;
          this.displayState = this.selectedState;
          this.currentVal = data;
          this.updatVal = '';
          this.successMess = false;
          this.showErrorDiv = false;
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });
    this.errorAnnouncement();
  }

  // Method for on key enter submit
  trackKeyPress(e: KeyboardEvent) {
    console.log('KEY CODE  ', e.keyCode);
    if (e.keyCode === 13)
    {this.updateGseLimit();}
  }
}
